module.exports = __webpack_public_path__ + "static/media/181MT035.aa34d07e.jpeg";